import lodash from "lodash";
import React from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Typography, Button, Tooltip } from "antd";
import { LiaSortAlphaDownSolid, LiaSortAlphaUpAltSolid } from "react-icons/lia";
import { useSelector } from "react-redux";
import {
  bailiffDocumentAllSelector,
  bailiffDocumentSortSelector,
} from "store/bailiff/bailiff/document/bailiff_document.selector";
//
//component
import empty from "asset/img/placeholder/empty_folder.webp";
import CardDocument from "component/cards/bailiff/card_document";
import CardDocumentSke from "component/cards/bailiff/card_document_ske";
//redux
//selector
//actions
import { setBailiffDocumentSort } from "store/bailiff/bailiff/document/bailiff_document.action";
import moment from "moment";
//utils
//hook
//str

const BailiffListing = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const data = useSelector(bailiffDocumentAllSelector);
  const sort = useSelector(bailiffDocumentSortSelector);
  const filter = renderFilterDelete(data);
  const sorter = lodash.orderBy(filter, "name", sort) || [];
  const title = sort === "asc" ? "Từ A-Z" : "Từ Z-A";

  // -------------------------- FUNCTION ------------------------
  const toggleSort = () => {
    const reverse = sort === "asc" ? "desc" : "asc";
    dispatch(setBailiffDocumentSort(reverse));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const icon =
    sort === "asc" ? (
      <LiaSortAlphaDownSolid size={30} />
    ) : (
      <LiaSortAlphaUpAltSolid size={30} />
    );
  const renderBody = () => {
    return (
      <Row gutter={[20, 20]}>
        <Col xl={12} lg={12} md={20} xs={20}>
          <Typography.Text style={{ fontSize: 18 }}>
            File này sẽ tự động xoá trong 24h sau khi bạn tải về
          </Typography.Text>
        </Col>
        <Col align="right" xl={12} lg={12} md={4} xs={4}>
          <Tooltip title={`Sắp xếp theo thứ tự ${title}`}>
            <Button
              onClick={toggleSort}
              size="large"
              type="text"
              shape="circle"
              icon={<span className="anticon">{icon}</span>}
            />
          </Tooltip>
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          {renderLists()}
          {renderEmpty()}
          {renderSkeleton()}
        </Col>
      </Row>
    );
  };

  const renderLists = () => {
    if (!data) return null;
    return (
      <Row gutter={[10, 10]}>
        {sorter?.map((item) => (
          <Col key={item?.id} xl={8} lg={8} md={8} xs={12}>
            <CardDocument data={item} />
          </Col>
        ))}
      </Row>
    );
  };

  const renderSkeleton = () => {
    if (data) return null;
    const samples = new Array(4).fill(null);
    return (
      <Row gutter={[10, 10]}>
        {samples?.map((item, index) => (
          <Col key={index} xl={6} lg={6} md={8} xs={12}>
            <CardDocumentSke />
          </Col>
        ))}
      </Row>
    );
  };

  const renderEmpty = () => {
    if (data?.length === 0) {
      return (
        <div
          style={{
            width: "100%",
            minHeight: 300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 20,
          }}
        >
          <img src={empty} style={{ width: 70 }} alt="empty" />
          <div style={{ color: "#aeaeae" }}>Thư mục trống</div>
        </div>
      );
    }
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Row
      style={{ minHeight: "60vh", background: "#fff", padding: "20px 10px" }}
      justify="center"
    >
      <Col xl={14} lg={14} md={24} xs={24}>
        {renderBody()}
      </Col>
    </Row>
  );
};
export default BailiffListing;

const renderFilterDelete = (data) => {
  const filter = data?.filter((d) => {
    const status = d?.status || null;
    const downloadedAt = d?.downloadedAt;
    const deletingAt = d?.deletingAt;
    const mDonwload = moment(downloadedAt?.toDate()).add(1, "days");
    const mDeleteAt = moment(deletingAt?.toDate()).add(10, "minutes");

    // th1.
    const valid1 = status === "ready for download";
    // th2.
    const validStatus2 = status === "downloaded";
    const valid2 = validStatus2 && moment()?.diff(mDonwload, "second") < 0;
    // th3.
    const validStatus3 = status === "deleting";
    const valid3 = validStatus3 && moment()?.diff(mDeleteAt, "second") < 0;
    return valid1 || valid2 || valid3;
  });

  return filter;
};
